module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quality-company-list"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right-list"
  }, [_c('list-tile', {
    attrs: {
      "title-text": _vm.titleText
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "entry-flexbox"
  }, _vm._l((_vm.newCompanyList), function(item) {
    return _c('entry-list-item', {
      attrs: {
        "item": item
      }
    })
  }))], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-brand onepx-r"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/lace.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-9409980a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homePageLists/quality-list.vue
// module id = 850
// module chunks = 39